import Card from "@/components/ui/Card";
import {
  faAsterisk,
  faUserTie,
  faUniversity,
  faUsers,
  faGlobeEurope,
} from "@fortawesome/pro-duotone-svg-icons";
import CorporateSteps from "./CorporateSteps";
import { useContext, useState } from "react";
import CorporateHeaderItem from "@/components/corporate/CorporateHeaderItem";
import { CorporateVerificationContext } from "@/context/corporate_verification";
import EditDocumentRegistrationNumber from "@/components/corporate/EditRegistrationNumber";
import EditCountry from "@/components/corporate/EditCountry";
import HeaderButton from "@/components/ui/HeaderButton";
import { faThumbtack } from "@fortawesome/pro-duotone-svg-icons";
import IdentityService from "@/services/identity";
import PinCorporateSidebar from "@/components/corporate/PinCorporateSidebar";
import * as Notification from "@/components/ui/Notification";

export default function CorporateVerificationHeader() {
  const [corporateVerification] = useContext(CorporateVerificationContext);
  const [editRegistrationNumber, setEditRegistrationNumber] = useState(false);
  const [editCountry, setEditCountry] = useState(false);
  const [pinOpen, setPinOpen] = useState(false);

  async function UnpinTask() {
    await IdentityService.UnpinTask(corporateVerification.task.session_id)
      .then(async () => {
        window.location.reload();
      })
      .catch((err) => {
        Notification.error(err.message);
      });
    return () => {};
  }

  return (
    <>
      <div className="flex flex-wrap justify-between pb-3">
        <div className="flex">
          <div className="ml-3 sm:ml-0">
            <img
              className="h-8 rounded-lg"
              src={corporateVerification.app.logo_url}
            ></img>
          </div>
          <div className="ml-3">
            {corporateVerification.task.pin === false ? (
              <HeaderButton
                onClick={() => setPinOpen(true)}
                currentBg="primary-500"
                icon={faThumbtack}
                type="pin"
                label="Pin"
              ></HeaderButton>
            ) : (
              <HeaderButton
                currentBg="primary-500"
                onClick={() => UnpinTask()}
                icon={faThumbtack}
                type="pin"
                label="Unpin"
              ></HeaderButton>
            )}
          </div>
          <div className="ml-2">
            <p className="text-white text-2xs uppercase font-bold">
              {corporateVerification.app.name}
            </p>
            <h1 className="text-2xs text-white">
              {corporateVerification.task.session_id}
            </h1>
          </div>
        </div>
      </div>
      <div className="flex flex-wrap">
        <Card className="w-full px-3 sm:px-0">
          <div className="flex p-4 justify-between">
            <div className="flex">
              <div className="p-3 ml-2">
                <h3 className="text-2xl">
                  <span className="font-bold">
                    {corporateVerification.verification.corporate.name}
                  </span>
                </h3>
                <h3 className="text-lg mt-1">
                  <span className="font-light">
                    {corporateVerification.verification.corporate.address}
                    {corporateVerification.verification.corporate.zipcode !== ""
                      ? corporateVerification.verification.corporate.zipcode
                      : null}
                  </span>
                </h3>
                <h3 className="text-lg mt-1">
                  <span className="font-light">
                    {corporateVerification.verification.corporate.city}
                    {", "}
                    {corporateVerification.verification.corporate.country}
                  </span>
                </h3>
              </div>
            </div>
            <div className="rounded-xl h-full md:w-4/6 w-full">
              <div className="flex flex-wrap">
                <div className="w-full md:w-1/3">
                  <CorporateHeaderItem
                    label="Registration Number"
                    onEdit={() => setEditRegistrationNumber(true)}
                    value={
                      corporateVerification.verification.corporate
                        .registration_number
                    }
                    editable
                    icon={faAsterisk}
                  ></CorporateHeaderItem>
                </div>
                <div className="w-full md:w-1/3">
                  <CorporateHeaderItem
                    label="Corporate Country"
                    onEdit={() => setEditCountry(true)}
                    value={corporateVerification.verification.corporate.country}
                    editable
                    icon={faGlobeEurope}
                  ></CorporateHeaderItem>
                </div>
                <div className="w-full md:w-1/3">
                  {corporateVerification.verification.owner_step.identity
                    .document.firstname !== "" ? (
                    <CorporateHeaderItem
                      label="Corporate Officer"
                      value={`
											${corporateVerification.verification.owner_step.identity.document.firstname} ${corporateVerification.verification.owner_step.identity.document.lastname}`}
                      icon={faUserTie}
                    ></CorporateHeaderItem>
                  ) : (
                    <CorporateHeaderItem
                      label="Corporate Officer"
                      value={"Not verified"}
                      icon={faUserTie}
                    ></CorporateHeaderItem>
                  )}
                </div>
                <div className="w-full md:w-1/3">
                  <CorporateHeaderItem
                    label="Corporates"
                    value={
                      corporateVerification.verification
                        .global_corporate_index_list.length
                    }
                    icon={faUniversity}
                  ></CorporateHeaderItem>
                </div>
                <div className="w-full md:w-1/3">
                  <CorporateHeaderItem
                    label="Individuals"
                    value={
                      corporateVerification.verification
                        .global_member_index_list.length
                    }
                    icon={faUsers}
                  ></CorporateHeaderItem>
                </div>
              </div>
            </div>
          </div>
          <div>
            <CorporateSteps></CorporateSteps>
          </div>
        </Card>
      </div>
      <EditDocumentRegistrationNumber
        open={editRegistrationNumber}
        setOpen={setEditRegistrationNumber}
      ></EditDocumentRegistrationNumber>
      <EditCountry open={editCountry} setOpen={setEditCountry}></EditCountry>
      <PinCorporateSidebar
        open={pinOpen}
        setOpen={setPinOpen}
      ></PinCorporateSidebar>
    </>
  );
}
